import {
  useCallback,
  useEffect,
  useState,
} from 'react';
import {
  ProfileSimilarCandidates,
} from '@components/templates/cv/sections/index';
import {
  ApiSimilarCandidate,
  fetcher,
  isSimilarCandidateStatusOk,
} from '@utils/data-fetching';
import { CvDetailObject } from '../interface/CvDetailInterface';

export const ProfileSimilarWrapper = ({
  cvDetail,
  locale,
  jobSlug,
  itemsPerPage = 12,
}: {
  cvDetail: CvDetailObject
  locale: Locale,
  jobSlug?: string,
  itemsPerPage?: number,
}) => {
  const slug = cvDetail?.slug;
  const [candidates, setCandidates] = useState<ApiSchema<'ResumeCardData'>[]>([]);

  const [isSimilarCandidatesLoaded, setIsSimilarCandidatesLoaded] = useState<boolean>(false);

  const fetchSimilarCandidates = useCallback(() => {
    fetcher<ApiSimilarCandidate>(`/v1/${slug}/similar-users?limit=${itemsPerPage}${jobSlug ? `&jobSlug=${jobSlug}` : ''}`, locale, {
      method: 'GET',
    })
      .then((response) => {
        if (isSimilarCandidateStatusOk(response)) {
          setCandidates(response as []);
          setIsSimilarCandidatesLoaded(true);
        }
      })
      .catch(() => {
      });
  }, [jobSlug, locale, slug, itemsPerPage]);

  useEffect(() => {
    fetchSimilarCandidates();
  }, [fetchSimilarCandidates]);

  return (
    <>
      { isSimilarCandidatesLoaded && !cvDetail?.isOwnCV && (
      <ProfileSimilarCandidates
        candidates={candidates}
        userSlug={slug}
        locale={locale}
        itemsPerPage={itemsPerPage}
      />
      )}
    </>
  );
};
